rs.module("development/codedemossearchcontroltest",

    [],

    function () {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, searchControl1Api, searchControl2Api) {

            searchControl1Api.onSelectionComplete(function (accountPartyKey) {
                $.js(jsSelectors.person1APK).html(accountPartyKey);
            });

            searchControl1Api.onSelectionCleared(function () {
                $.js(jsSelectors.person1APK).empty();
                $.js(jsSelectors.person1Value).empty();
            });

            searchControl2Api.onSelectionComplete(function (accountPartyKey) {
                $.js(jsSelectors.person2APK).html(accountPartyKey);
            });

            searchControl2Api.onSelectionCleared(function () {
                $.js(jsSelectors.person2APK).empty();
                $.js(jsSelectors.person2Value).empty();
            });

            $.js(jsSelectors.clearButton1).click(function () {
                searchControl1Api.clear();
            });

            $.js(jsSelectors.clearButton2).click(function () {
                searchControl2Api.clear();
            });

            $.js(jsSelectors.getValueButton1).click(function () {
                var person1Value = searchControl1Api.getValue();
                $.js(jsSelectors.person1Value).html(person1Value);
            });

            $.js(jsSelectors.getValueButton2).click(function () {
                var person2Value = searchControl2Api.getValue();
                $.js(jsSelectors.person2Value).html(person2Value);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);